import React, { useEffect, useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Button, CircularProgress, TextField } from '@material-ui/core';
import ModalCustom from './../../../../common/modalCustom/modalCustom';
import { notificationAlertErrorApi } from '../../../../../components/method/notificationAlertErrorApi/notificationAlertErrorApi';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import OtpComponent from '../../components/otp/index';
import Timer from '../../components/timer/index';
import { send_contract_otp_api } from '../../../../../redux/register/contarct/sendContractOTP/sendContractOTP';
import { actionTypes as actionTypesNotif } from './../../../../../redux/notificationAlert/index';
import { save_online_contract_api } from '../../../../../redux/register/contarct/saveOnlineContract/saveOnlineContract';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


let useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        padding: '10px 16px 10px 16px',
        position: 'relative',
        "@media(max-width : 350px)": {
            padding: '0px',
        },
    },
    gridCard: {
        marginTop: 21,
    },
    gridMassege: {
        width: '100%',
        height: 58,
        padding: '10px',
        borderRadius: 8,
        border: '1px solid #D9D9D9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        bottom: 0,
    },
    TextField: {
        width: '100%%',
        '& input': {
            fontSize: 14,
            height: '20p !important',
            borderRadius: 16,
            padding: '10px 5px',
            width: '100%'
        },
        '& fieldset': {
            border: 'none',
        }
    },
    icons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        fontSize: 14,
        fontWeight: 700
    },
    Button: {
        width: '100%',
        padding: '10px 55px !important',
        backgroundColor: "#091742 !important",
        color: 'white !important',
        marginTop: '0px !important',
        borderRadius: '8px !important '
    },
    cardIcon: {
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '1px 1px 5px rgba(0,0,0,0.1)',
        borderRadius: 8,
        cursor: 'pointer',
        margin: 5,
    },
    modal: {
        width: '518px',
        maxWidth: '98%',
        borderRadius: '12px 12px 12px 12px !important',
        "@media(max-width : 900px)": {
            maxWidth: 360
        },
        "@media(max-width : 400px)": {
            maxWidth: '100%',
        },
    },
    close: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        padding: '10px'
    }
}))




const Contract = ({ open, onClose, openSuccess }) => {

    let classes = useStyles()
    const location = useLocation();
    let dispatch = useDispatch();
    const formikRef = useRef();
    const history = useHistory();

    const { token, national_id, servics } = location?.state?.state || location?.state || {};
    const [InputSmsCode, setInputSmsCode] = useState({
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
        6: "",
    });

    const initialValues = {
        otp: '',
    };


    const validationSchema = Yup.object().shape({
        otp: Yup.string()
            .matches(/^\d{5}$/, ' کد تایید باید 5 رقم باشد')
            .required('کد تایید الزامی است'),
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        apiSubmitGetProfileOtpSejam(values, setSubmitting, resetForm)
    };


    const apiSubmitGetProfileOtpSejam = (values, setSubmitting, resetForm) => {

        setSubmitting(true)

        let payload = {
            data: {
                NationalCode: national_id,
                Otp: values?.otp
            },
            headers: {
                token: token
            }
        }

        save_online_contract_api(payload)
            .then((res) => {

                if (res?.data === "آخرین کد دریافتی را مجدد وارد کنید") {
                    dispatch(({ type: actionTypesNotif?.info, textAlert: 'آخرین کد دریافتی را مجدد وارد کنید' }))
                }
                if (res?.data) {

                    if (servics === 'sejam') {
                        history.push('/register/sejam/success', {
                            ...location.state
                        });
                    }
                    if (servics === 'changeOms') {
                        history.push('/register/changeOms', {
                            ...location.state
                        });
                    }
                    onClose()
                }
            })
            .catch((error) => {
                notificationAlertErrorApi(error, dispatch)
                resetForm()
                setInputSmsCode({
                    1: "",
                    2: "",
                    3: "",
                    4: "",
                    5: "",
                    6: "",
                })
            })
            .finally(() => {
                setSubmitting(false)
            })
    }



    const sentOtpContarct = () => {
        let payload = {
            data: {
                NationalCode: national_id,
            },
            headers: {
                token: token
            },
        }
        send_contract_otp_api(payload)
            .then((res) => {
                if (res?.data?.data === "آخرین کد دریافتی را مجدد وارد کنید") {
                    dispatch(({ type: actionTypesNotif?.info, textAlert: 'آخرین کد دریافتی را مجدد وارد کنید' }))
                    return
                }
                if (res?.status === 200) {
                    if (res?.data) {
                        dispatch(({ type: actionTypesNotif?.success, textAlert: res?.data }))
                    }
                    if (res?.data?.message) {
                        dispatch(({ type: actionTypesNotif?.info, textAlert: res?.data?.message }))
                    }
                }
            })
            .catch((error) => {
                notificationAlertErrorApi(error, dispatch)
            })
            .finally(() => { })
    }

    useEffect(() => {
        if (open)
            sentOtpContarct()
    }, [open])

    return (
        <ModalCustom
            open={open}
            onClose={onClose}
            className={classes['modal']}
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                className={classes['root']}
                innerRef={formikRef}
            >
                {({ isSubmitting, errors, touched, setFieldValue }) => {
                    return (
                        <Form>
                            <div className={classes['root']} onClick={(event) => event.stopPropagation()}>
                                <div className={classes['close']}>
                                    <p className={classes['title']}>
                                        امضای قرارداد
                                    </p>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => onClose()}>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0003 13.4141L17.6573 19.0711C17.8459 19.2533 18.0985 19.3541 18.3607 19.3518C18.6229 19.3495 18.8737 19.2444 19.0591 19.059C19.2445 18.8736 19.3497 18.6227 19.352 18.3606C19.3543 18.0984 19.2535 17.8458 19.0713 17.6571L13.4143 12.0001L19.0713 6.34315C19.2535 6.15455 19.3543 5.90194 19.352 5.63975C19.3497 5.37755 19.2445 5.12674 19.0591 4.94133C18.8737 4.75592 18.6229 4.65075 18.3607 4.64848C18.0985 4.6462 17.8459 4.74699 17.6573 4.92915L12.0003 10.5861L6.34331 4.92915C6.15386 4.75149 5.90272 4.65451 5.64304 4.65873C5.38336 4.66295 5.1355 4.76803 4.95192 4.95174C4.76834 5.13546 4.66343 5.38339 4.6594 5.64307C4.65537 5.90276 4.75252 6.15382 4.93031 6.34315L10.5863 12.0001L4.92931 17.6571C4.8338 17.7494 4.75762 17.8597 4.70521 17.9817C4.6528 18.1037 4.62522 18.235 4.62406 18.3677C4.62291 18.5005 4.64821 18.6322 4.69849 18.7551C4.74877 18.878 4.82302 18.9897 4.91692 19.0835C5.01081 19.1774 5.12246 19.2517 5.24536 19.302C5.36825 19.3523 5.49993 19.3776 5.63271 19.3764C5.76549 19.3752 5.89671 19.3477 6.01872 19.2953C6.14072 19.2428 6.25106 19.1667 6.34331 19.0711L12.0003 13.4141Z" fill="#7E8E9D" />
                                    </svg>
                                </div>
                                <div className={classes['gridCard']}>
                                    <p>
                                        برای امضای قرارداد کد تایید به شماره موبایلی که در سجام ثبت شده
                                        را وارد نمایید.
                                    </p>
                                </div>

                                <div className={classes['gridCard']} style={{ marginTop: 16 }}>
                                    <div className={classes['gridTextField']}>
                                        <OtpComponent
                                            InputSmsCode={InputSmsCode}
                                            setInputSmsCode={setInputSmsCode}
                                            numberOtp={5}
                                            submiting={() => formikRef.current?.submitForm()}
                                            formikCustom={{
                                                key: 'otp',
                                                setFieldValue: setFieldValue,
                                                errors: errors,
                                                touched: touched,
                                            }
                                            }
                                        />
                                    </div>
                                    <div>
                                        <Timer
                                            initialMinute={2}
                                            initialSeconds={0}
                                            handleClickAgain={() => sentOtpContarct()}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div onClick={(event) => event.stopPropagation()}>
                                <Button
                                    disabled={isSubmitting}
                                    startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
                                    className={classes['Button']}
                                    onClick={() => formikRef.current?.submitForm()}
                                >
                                    تایید
                                </Button>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </ModalCustom>

    )
}


export default Contract;